import React from 'react';
import { Paper, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, CircularProgress, Box, Typography } from '@mui/material';
import { TabPanel } from '@mui/lab';
import { SearchOutlined } from '@mui/icons-material';
import styled from '@emotion/styled';
import { useNavigate } from 'react-router-dom';

const StyledTabPanel = styled(TabPanel)(({ theme }) => ({
  padding: theme.spacing(0),
}));

const LoadingBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  padding: theme.spacing(8),
}));

const ClientCell = styled(TableCell)(({ theme }) => ({
  cursor: 'pointer',
  fontWeight: 'bold',
  '&:hover': { color: theme.palette.primary.dark },
}));

const NinetyPlusCell = styled(TableCell, { shouldForwardProp: (prop) => prop !== 'overdue' })(({ theme, overdue }) => ({
  color: overdue ? theme.palette.error.main : 'inherit',
}));

const EmptyStateBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: theme.spacing(1),
  paddingTop: theme.spacing(4),
  paddingBottom: theme.spacing(4),
}));

const fmt = (v) => `$ ${(v || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

const ArAgingTable = ({ data, loading, hasFetched }) => {
  const navigate = useNavigate();

  return (
    <StyledTabPanel value="ar-aging">
      <Paper>
        <TableContainer>
          {loading ? (
            <LoadingBox><CircularProgress /></LoadingBox>
          ) : (
            <Table stickyHeader>
              <TableHead>
                <TableRow key="header">
                  <TableCell>Client</TableCell>
                  <TableCell align="right">Open Invoices</TableCell>
                  <TableCell align="right">Current</TableCell>
                  <TableCell align="right">1–30 Days</TableCell>
                  <TableCell align="right">31–60 Days</TableCell>
                  <TableCell align="right">61–90 Days</TableCell>
                  <TableCell align="right">90+ Days</TableCell>
                  <TableCell align="right">Total Outstanding</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {data.map((row) => (
                  <TableRow key={row.clientId} hover>
                    <ClientCell onClick={() => row.clientSlug && navigate(`/client/${row.clientSlug}`)}>{row.clientName}</ClientCell>
                    <TableCell align="right">{row.invoiceCount}</TableCell>
                    <TableCell align="right">{fmt(row.current)}</TableCell>
                    <TableCell align="right">{fmt(row.d1to30)}</TableCell>
                    <TableCell align="right">{fmt(row.d31to60)}</TableCell>
                    <TableCell align="right">{fmt(row.d61to90)}</TableCell>
                    <NinetyPlusCell align="right" overdue={row.d90plus > 0}>{fmt(row.d90plus)}</NinetyPlusCell>
                    <TableCell align="right"><strong>{fmt(row.total)}</strong></TableCell>
                  </TableRow>
                ))}
                {data.length === 0 && (
                  <TableRow>
                    <TableCell colSpan={8} align="center">
                      <EmptyStateBox>
                        <SearchOutlined />
                        <Typography variant="body1">{hasFetched ? 'No outstanding invoices' : 'Click Generate Report to load data'}</Typography>
                      </EmptyStateBox>
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          )}
        </TableContainer>
      </Paper>
    </StyledTabPanel>
  );
};

export default ArAgingTable;
